<template>
    <content-page title="Κανονισμός" icon="mdi-gavel" :loading="!regulations">
        <div v-if="regulations" v-html="regulations.content" />
    </content-page>
</template>

<script>
    import configService from '@/services/config'
    import ContentPage from '@/components/ContentPage'
    export default {
        components: { ContentPage },
        data() {
            return {
                regulations: null
            }
        },
        created() {
            this.getRegulations()
        },
        methods: {
            getRegulations() {
                configService.getConfigField('regulation').then(resp => {
                    this.regulations = resp.data
                })
            }
        }
    }
</script>
